import { render, staticRenderFns } from "./DispatchUpdate.vue?vue&type=template&id=ff8751b4&"
import script from "./DispatchUpdate.vue?vue&type=script&lang=tsx&"
export * from "./DispatchUpdate.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports